import * as R from 'ramda';
export function mapAjvErrors(valErrors) {
    if (!valErrors)
        return [];
    return R.uniq(valErrors.map((e) => `${e.instancePath || '/root'}  |  ${e.message}`));
}
